enum ApiContentType {
  JSON = 0,
  FormData = 1,
  Excel = 2,
  PDF = 3
}
export default Object.freeze(ApiContentType);
